import React from "react";
import Accordion from "react-bootstrap/Accordion";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Utils from "../../services/Utils";
import { getImageFullUrl } from '../../services/ApiService'; //@@@

/**
 * PreconisationsList Component
 *
 * Displays an accordion list item for an operation with its PLVs and preco images.
 *
 * @param {Object} props
 * @param {Object} props.operation - The operation object
 * @param {Function} props.handleShowModal - Function to open the modal for this operation
 */
export default function PreconisationsList({ operation, handleShowModal }) {
  return (
    <div>
      <Accordion>
        <Accordion.Item
          eventKey="0"
          className="mb-5 w-100 m-auto"
          style={{
            backgroundColor: Utils.getColorAlternative(operation.color, 20),
          }}
        >
          <div className="row w100">
            <div className="col-10">
              <Accordion.Header as="div">
                <div className="row w100">
                  <div className="col-10">
                    <span
                      style={{ backgroundColor: operation.brand?.color || "#333" }}
                      className="rounded white marque"
                    >
                      {operation.brand?.name || "N/A"}
                    </span>
                    <div className="mr-2 text-start">
                      <span
                        className="accordion-title"
                        style={{ color: operation.color }}
                      >
                        {operation.name}{" "}
                      </span>
                      <LocalOfferOutlinedIcon
                        style={{ color: operation.color }}
                        className="ms-3"
                      />
                    </div>
                  </div>
                </div>
              </Accordion.Header>
            </div>
            <div className="col-2 text-end pt-2">
              <DropdownButton title={<MoreVertIcon />} className="hidden-arrow">
                <Dropdown.Item
                  onClick={() => {
                    handleShowModal(operation);
                  }}
                >
                  <EditOutlinedIcon className="grey" /> Modifier
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>

          <div className="container-fluid">
            <Accordion.Body>
              <div className="row pt-0">
                <div className="col-md-12 pb-5 have-border-top pt-3">
                  <div className="data-label mb-3">PLV et Préconisations</div>
                  {operation.operation_plvs_used &&
                  operation.operation_plvs_used.length > 0 ? (
                    <div className="row">
                      {operation.operation_plvs_used.map((plv) => (
                        <div key={plv.id} className="col-md-4 mb-4">
                          <div
                            style={{
                              border: "1px solid #dee2e6",
                              borderRadius: "8px",
                              padding: "1rem",
                              height: "100%",
                            }}
                          >
                            <div
                              className="d-flex align-items-center gap-2 mb-2"
                              style={{ fontWeight: "600" }}
                            >
                              <LocalOfferOutlinedIcon
                                style={{ fontSize: "1.2rem", color: "#6c757d" }}
                              />
                              {plv.name}
                            </div>

                            {plv.preco ? (
                              <div
                                style={{
                                  border: "1px solid #dee2e6",
                                  borderRadius: "4px",
                                  overflow: "hidden",
                                  backgroundColor: "#f8f9fa",
                                }}
                              >
                                <img
                                  src={getImageFullUrl(plv.preco)}
                                  alt={`Preco ${plv.name}`}
                                  style={{
                                    width: "100%",
                                    height: "150px",
                                    objectFit: "contain",
                                    padding: "0.5rem",
                                  }}
                                />
                              </div>
                            ) : (
                              <div
                                className="d-flex flex-column align-items-center justify-content-center"
                                style={{
                                  border: "1px dashed #ced4da",
                                  borderRadius: "4px",
                                  padding: "2rem",
                                  backgroundColor: "#f8f9fa",
                                  color: "#6c757d",
                                  height: "150px",
                                }}
                              >
                                <ImageNotSupportedOutlinedIcon
                                  style={{ fontSize: "2rem", marginBottom: "0.5rem" }}
                                />
                                <span style={{ fontSize: "0.875rem" }}>
                                  Aucune image
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      className="text-center text-muted py-4"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Aucun PLV associé à cette opération.
                    </div>
                  )}
                </div>
              </div>
            </Accordion.Body>
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
